import { Directive } from '@angular/core';

@Directive({
  selector: '[prizmAccordionContent]',
  standalone: true,
})
export class PrizmAccordionContentDirective {}
